<div class="modal-backdrop"></div>
<div class="panel" [@slideInOut]="panelState" [ngStyle]="{ 'width': panelWidth }">
  <div class="header">
    <div class="title">{{ title }}</div>
    <app-svg-icon
      class="close_btn"
      (click)="onClose()"
      [path]="'assets/icons/close_icon.svg'"
    ></app-svg-icon>
  </div>
  <div class="divider"></div>

  <div class="body" [class.loading]="isLoading">
    @if (isLoading) {
      <app-spinner-loader></app-spinner-loader>
    }
    <ng-template #rightPanelContent></ng-template>
  </div>
  @if (showActionBtns) {
    <div class="divider"></div>
    <div class="action_btns">
      <button class="secondary_button" (click)="onClose()">{{ secondaryActionBtnText }}</button>
      <button *ngIf="!hidePrimaryButton" class="primary_button"
              (click)="handlePrimaryBtnClick()">{{ primaryActionBtnText }}
      </button>
    </div>
  }
</div>

